import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import AdminApp from './admin/AdminApp';
import { SessionProvider } from './lib/session';
import { AdminSessionProvider } from './admin/session';
import { ConfirmProvider } from './components/confirm';
import { LocaleProvider } from './i18n/locale';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root element is missing from index.html');

/*
 * /admin is a different application that happens to share a bundle.
 *
 * Branching at the root rather than routing into it means the customer
 * SessionProvider never mounts there — so the admin console cannot read, 
 * refresh or accidentally act on a tenant session, and a logged-in customer
 * visiting /admin simply sees the admin login.
 *
 * Read once at startup: both areas use client-side routing within themselves,
 * and nothing navigates between them.
 */
const isAdminArea = window.location.pathname.startsWith('/admin');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <LocaleProvider>
      {isAdminArea ? (
        <AdminSessionProvider>
          <ConfirmProvider>
            <AdminApp />
          </ConfirmProvider>
        </AdminSessionProvider>
      ) : (
        <SessionProvider>
          <ConfirmProvider>
            <App />
          </ConfirmProvider>
        </SessionProvider>
      )}
      </LocaleProvider>
    </BrowserRouter>
  </StrictMode>,
);
